import { Roles } from '../wf-constants'

type MuiPaletteColor = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'default' | undefined

export function getColorByRole(role: string): MuiPaletteColor {
  switch (role.toLowerCase()) {
    case Roles.Admin:
      return 'primary'
    case Roles.Contributor:
      return 'info'
    case Roles.ViewOnly:
      return 'warning'
    default:
      return 'secondary'
  }
}
